import React from 'react';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import { ComponentIds } from '@inter-ikea-core/core';
import { SlidingDoorComponent } from '@inter-ikea-storageone/range';
import { useCore } from 'contexts/core';
import { getAllowedHandleTypes } from 'rangeConfig/shared/utils/frontLayouts';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import media from 'ui/media';

const Box = styled.div`
  padding: ${({ theme }) => theme.space.xs} 0 ${({ theme }) => theme.space.s} 0;
  ${media.mobile`
   padding: 1.5rem 1.5rem 0 1.5rem;
  `}
`;

const IntegratedHandlesInfoMessage = () => {
  const { formatMessage } = useIntl();
  const coreApi = useCore();
  const selectedEntity = coreApi.entities.findSelectedEntity();
  let infoMessage;

  if (selectedEntity) {
    if (getAllowedHandleTypes(selectedEntity).length === 0) {
      infoMessage = 'storageone.integratedHandlesInfoMessageSelectedFront';
    } else {
      return null;
    }
  } else {
    const frontsInScene = coreApi.entities.getByComponents([
      ComponentIds.DOOR_COMPONENT_ID,
      ComponentIds.DRAWER_COMPONENT_ID,
      SlidingDoorComponent.id
    ]);
    if (frontsInScene.length === 0) {
      return null;
    }

    const frontsWithIntegratedHandles = frontsInScene.filter(
      front => getAllowedHandleTypes(front).length === 0
    );
    if (frontsInScene.length === frontsWithIntegratedHandles.length) {
      infoMessage = 'storageone.integratedHandlesInfoMessageAll';
    } else if (frontsWithIntegratedHandles.length !== 0) {
      infoMessage = 'storageone.integratedHandlesInfoMessageSome';
    } else {
      return null;
    }
  }

  return (
    <Box>
      <SkapaInlineMessage
        body={formatMessage({ id: infoMessage })}
        variant={InlineMessageVariantEnum.INFORMATIVE}
        ssrIcon={InformationCircle}
        subtle
      />
    </Box>
  );
};
export default IntegratedHandlesInfoMessage;
